var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeviceAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70457 4.5H24.0068C26.6855 4.5 28.8542 6.669 28.8572 9.348V23.652C28.8572 26.331 26.6854 28.5 24.0098 28.5H9.70457C7.02591 28.5 4.85718 26.331 4.85718 23.655V9.348C4.85718 6.669 7.02591 4.5 9.70457 4.5ZM16.6416 9.07127L16.1592 9.9425L15.6858 9.06816C15.3821 8.52365 14.724 8.34007 14.2029 8.65122C13.6818 8.96859 13.5061 9.65624 13.8039 10.2008L14.9086 12.2046L11.3711 18.6112H8.60774C8.00624 18.6112 7.52384 19.1152 7.52384 19.7437C7.52384 20.3723 8.00624 20.8763 8.60774 20.8763H18.464C18.9375 19.9491 18.327 18.6112 17.2372 18.6112H13.8753L18.5236 10.2039C18.8213 9.65935 18.6456 8.96548 18.1245 8.65433C17.6034 8.34318 16.9394 8.52676 16.6416 9.07127ZM10.9363 23.9318L11.9785 22.0432C11.4157 21.3337 10.7041 21.1159 9.8286 21.3991L9.0544 22.7992C8.75662 23.3438 8.93231 24.0376 9.45341 24.3488C9.97451 24.6599 10.6385 24.4764 10.9363 23.9318ZM23.7733 18.6174H20.9534C20.7374 18.2266 20.5297 17.8507 20.3302 17.4897C19.2178 15.4766 18.3617 13.9273 17.7583 12.8455C17.1181 13.4025 16.4689 15.0454 17.3771 16.682C17.7711 17.3962 18.2536 18.2691 18.8242 19.3014C19.539 20.5945 20.392 22.1376 21.3822 23.9318C21.6859 24.4764 22.344 24.6599 22.8651 24.3488C23.3862 24.0314 23.5619 23.3438 23.2641 22.7992L22.207 20.8826H23.7733C24.3748 20.8826 24.8572 20.3785 24.8572 19.75C24.8572 19.1214 24.3748 18.6174 23.7733 18.6174Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceAppStore);
export default __webpack_public_path__ + "static/media/deviceAppStore.ec5cdc33aa76a1be9481e3f9b418b160.svg";
export { ForwardRef as ReactComponent };